export default __webpack_public_path__ + "static/media/hero_sixth.fcae96a6.jpg";